const features = [
  {
    title: "Smart Agent Workqueue",
    description: "AI-ranked call list with full borrower context and one-click actions.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4987 5.83333H8.16536C6.87756 5.83333 5.83203 6.87886 5.83203 8.16667V22.1667C5.83203 23.4545 6.87756 24.5 8.16536 24.5H19.832C21.1198 24.5 22.1654 23.4545 22.1654 22.1667V8.16667C22.1654 6.87886 21.1198 5.83333 19.832 5.83333H17.4987M10.4987 5.83333C10.4987 7.12113 11.5442 8.16667 12.832 8.16667H15.1654C16.4532 8.16667 17.4987 7.12113 17.4987 5.83333M10.4987 5.83333C10.4987 4.54553 11.5442 3.5 12.832 3.5H15.1654C16.4532 3.5 17.4987 4.54553 17.4987 5.83333M10.4987 16.3333L12.832 18.6667L17.4987 14" stroke="#0284C7" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Workflow Automation",
    description: "Trigger-based outreach rules with escalation matrix.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.66797 4.66671V10.5H5.34697M23.2623 12.8334C22.7317 8.6172 19.4203 5.29153 15.2064 4.74271C10.9926 4.19389 6.93985 6.56044 5.34697 10.5M5.34697 10.5H10.5013M23.3346 23.3334V17.5H22.6568M22.6568 17.5C21.0617 21.4372 17.0099 23.8013 12.7974 23.2527C8.58496 22.7041 5.27382 19.3811 4.7403 15.1667M22.6568 17.5H17.5013" stroke="#0284C7" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Payment & Settlement",
    description: "EMI restructuring, settlement approvals, webhook-verified payments.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 11.6654H24.5M8.16667 17.4987H9.33333M14 17.4987H15.1667M7 22.1654H21C22.9317 22.1654 24.5 20.5971 24.5 18.6654V9.33203C24.5 7.40033 22.9317 5.83203 21 5.83203H7C5.0683 5.83203 3.5 7.40033 3.5 9.33203V18.6654C3.5 20.5971 5.0683 22.1654 7 22.1654L3.5 11.6654" stroke="#0284C7" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Compliance Guardrails",
    description: "Quiet hours, contact caps, opt-out tracking, audit logs.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 13.9989L12.8333 16.3323L17.5 11.6656M24.0543 6.98026C20.3655 7.17616 16.7495 5.90064 14 3.43359C11.2505 5.90064 7.63455 7.17616 3.94567 6.98026C3.64879 8.12956 3.49904 9.3119 3.5 10.4989C3.5 17.0218 7.96134 22.5039 14 24.0579C20.0387 22.5039 24.5 17.0229 24.5 10.4989C24.5 9.28326 24.3448 8.10493 24.0543 6.98026L10.5 13.9989" stroke="#0284C7" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Self-Service Portal",
    description: "Secure payment links, callback scheduling, account summary access.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.6654 8.16667C18.6654 10.7423 16.5743 12.8333 13.9987 12.8333C11.4231 12.8333 9.33203 10.7423 9.33203 8.16667C9.33203 5.59106 11.4231 3.5 13.9987 3.5C16.5743 3.5 18.6654 5.59106 18.6654 8.16667V8.16667M13.9987 16.3333C9.49139 16.3333 5.83203 19.9927 5.83203 24.5H22.1654C22.1654 19.9927 18.506 16.3333 13.9987 16.3333V16.3333" stroke="#0284C7" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    title: "Advanced Analytics",
    description: "Collection funnel, DPD distribution, cohort retention, scheduled reports.",
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 22.1667V15.1667C10.5 13.8789 9.45447 12.8333 8.16667 12.8333H5.83333C4.54553 12.8333 3.5 13.8789 3.5 15.1667V22.1667C3.5 23.4545 4.54553 24.5 5.83333 24.5H8.16667C9.45447 24.5 10.5 23.4545 10.5 22.1667V22.1667M10.5 22.1667V10.5C10.5 9.2122 11.5455 8.16667 12.8333 8.16667H15.1667C16.4545 8.16667 17.5 9.2122 17.5 10.5V22.1667M10.5 22.1667C10.5 23.4545 11.5455 24.5 12.8333 24.5H15.1667C16.4545 24.5 17.5 23.4545 17.5 22.1667M17.5 22.1667V5.83333C17.5 4.54553 18.5455 3.5 19.8333 3.5H22.1667C23.4545 3.5 24.5 4.54553 24.5 5.83333V22.1667C24.5 23.4545 23.4545 24.5 22.1667 24.5H19.8333C18.5455 24.5 17.5 23.4545 17.5 22.1667H10.5" stroke="#0284C7" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="bg-white py-24 px-5 md:px-20">
      <div className="max-w-7xl mx-auto px-0 md:px-8 flex flex-col gap-16">
        {/* Header */}
        <div className="flex flex-col gap-4 items-center justify-center">
          <div className="bg-white rounded-full border border-[#bae6fd] pt-2 pr-4 pb-2 pl-4 shadow-sm">
            <span
              className="text-[#0369a1] font-bold text-xs leading-4 uppercase"
              style={{ letterSpacing: "0.6px" }}
            >
              Features
            </span>
          </div>
          <h2 className="text-[#111827] text-center font-['SpaceGrotesk-Bold',_sans-serif] text-4xl md:text-5xl lg:text-6xl leading-tight font-bold max-w-4xl">
            Powerful Features Built for Modern Lending Teams
          </h2>
        </div>

        {/* Feature Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-3xl border border-[#f3f4f6] p-8 flex flex-col gap-5 shadow-[0px_8px_30px_0px_rgba(0,0,0,0.12)]"
            >
              <div className="bg-[#eff6ff] rounded-3xl flex items-center justify-center w-14 h-14 shrink-0">
                {feature.icon}
              </div>
              <div className="flex flex-col gap-2">
                <h3 className="text-[#111827] font-['SpaceGrotesk-Bold',_sans-serif] text-xl leading-7 font-bold">
                  {feature.title}
                </h3>
                <p className="text-[#4b5563] font-normal text-base leading-[26px]">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="flex items-center justify-center">
          <a
            href="https://debtpulse.cloudastra.co"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#2563eb] rounded-lg pt-3.5 pr-8 pb-3.5 pl-8 shadow-[0px_4px_6px_-4px_rgba(30,58,138,0.2),0px_10px_15px_-3px_rgba(30,58,138,0.2)]"
          >
            <span className="text-white text-center font-semibold text-base leading-6">
              Explore DebtPulse
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
